import React, { FC } from 'react';

import { CoreUtils, CustomIcons } from '@nhl/nhl-breakaway-ui';

import commonMessages from '~/core/commonMessages';

import { Play as PlayType } from '../../../../types';

import { StoppageContainer, StoppageText } from './styles';

type Props = {
    play: PlayType;
};

const Stoppage: FC<Props> = ({ play }) => {
    const message = play?.details?.reason
        ? commonMessages.eventDescriptions[play?.details?.reason]
        : commonMessages.gameEventTypeDescriptions[play.typeDescKey];
    return message ? (
        <StoppageContainer $isGoalEvent={false}>
            <CustomIcons.WhistleIcon />
            <StoppageText>
                <CoreUtils.SafeFormattedMessage message={message} />
            </StoppageText>
        </StoppageContainer>
    ) : null;
};

export default Stoppage;
